import { JsonObject, JsonProperty } from 'json2typescript';
import { User } from '../users/user';
import { Client } from './client';

export enum HistoryType {
    CREATED = '+',
    UPDATED = '~',
    DELETED = '-',
}

@JsonObject('ClientHistory')
export class ClientHistory extends Client {
    @JsonProperty('history_id', Number, true)
    id: number = undefined;

    @JsonProperty('history_type', Number, true)
    historyType: HistoryType = null;

    @JsonProperty('history_date', String, true)
    historyDate = null;

    @JsonProperty('history_change_reason', String, true)
    changeReason = null;

    @JsonProperty('history_user', User, true)
    user = null;
}

